import gql from 'graphql-tag'

export const QUERY_BIG_NUMBERS_GENERAL_RESULTS = gql`
  query GeneralResultsIndustry(
    $franchise: Boolean
    $endDate: String
    $startDate: String
    $target: [String]
    $format: [String]
    $modality: [String]
    $status: [String]
    $industryIds: [ID]
  ) {
    generalResultsIndustry(
      franchise: $franchise
      endDate: $endDate
      startDate: $startDate
      target: $target
      format: $format
      modality: $modality
      status: $status
      industryIds: $industryIds
    ) {
      revenue
      rebate {
        counting
        counted
      }
      sale_units
      average_ticket
    }
  }
`

export const QUERY_GENERAL_RESULTS = gql`
  query offersGeneralResultsIndustry(
    $franchise: Boolean
    $endDate: String
    $startDate: String
    $target: [String]
    $format: [String]
    $modality: [String]
    $status: [String]
    $industryIds: [ID]
    $search: String
    $page: Int!
    $pageSize: Int!
    $sort: [String]
    $sortDirection: [SortDirection]
  ) {
    offersGeneralResultsIndustry(
      franchise: $franchise
      endDate: $endDate
      startDate: $startDate
      target: $target
      format: $format
      modality: $modality
      status: $status
      industryIds: $industryIds
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
    ) {
      offerSchedules {
        _id
        name
        start_date
        end_date
        modality
        types
        segments
        industry {
          name
          is_mercapromo
        }
        rebate
        month_rebate
        status
      }
      records
    }
  }
`
